module.exports = __webpack_public_path__ + "img/sample-banner-2.2b53cbe6.jpg";